module.exports = "<Toggle\n  name=\"toggleName1\"\n  value=\"toggleValue1\"\n  label=\"activate thrusters\"/>\n\n<Toggle\n  name=\"toggleName2\"\n  value=\"toggleValue2\"\n  label=\"auto-pilot\"\n  defaultToggled={true}/>\n\n<Toggle\n  name=\"toggleName3\"\n  value=\"toggleValue3\"\n  label=\"initiate self-destruct sequence\"\n  disabled={true}/>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/toggle-code.txt
 ** module id = 857
 ** module chunks = 0
 **/